import { render, staticRenderFns } from "./tchTree.vue?vue&type=template&id=60ae77a7&scoped=true"
import script from "./tchTree.vue?vue&type=script&lang=js"
export * from "./tchTree.vue?vue&type=script&lang=js"
import style0 from "./tchTree.vue?vue&type=style&index=0&id=60ae77a7&prod&lang=css"
import style1 from "./tchTree.vue?vue&type=style&index=1&id=60ae77a7&prod&lang=less"
import style2 from "./tchTree.vue?vue&type=style&index=2&id=60ae77a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae77a7",
  null
  
)

export default component.exports